import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TokenService } from '../../../services/token/token.service';

export const tokenResolver: ResolveFn<any> = (route, state) => {
  const tokenService = inject(TokenService);
  return tokenService.getToken();
};
